var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2430 5094 c-472 -32 -888 -170 -1265 -420 -158 -104 -263 -191 -405 -334 -402 -404 -649 -917 -721 -1495 -16 -129 -16 -451 0 -580 72 -578 319 -1091 721 -1495 303 -305 634 -508 1045 -639 248 -80 479 -114 760 -114 281 0 512 34 760 114 411 131 741 333 1045 639 402 404 649 917 721 1495 16 129 16 451 0 580 -72 578 -319 1091 -721 1495 -303 305 -634 508 -1045 639 -134 43 -326 84 -465 100 -99 12 -350 20 -430 15z m450 -270 c386 -55 745 -203 1060 -437 122 -91 366 -335 457 -457 303 -410 456 -870 456 -1375 0 -505 -153 -965 -456 -1375 -91 -122 -335 -366 -457 -457 -410 -303 -870 -456 -1375 -456 -505 0 -965 153 -1375 456 -122 91 -366 335 -457 457 -303 410 -456 870 -456 1375 0 505 153 965 456 1375 91 122 335 366 457 457 492 364 1099 522 1690 437z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3675 3827 c-94 -50 -220 -114 -1110 -568 -198 -101 -385 -197 -415 -214 l-55 -31 -148 -289 c-602 -1179 -707 -1389 -707 -1414 0 -35 37 -71 74 -71 15 0 123 49 244 111 457 235 610 313 1014 518 230 117 427 220 438 229 29 25 870 1677 870 1711 0 36 -38 71 -76 71 -16 0 -74 -24 -129 -53z m-1032 -967 c84 -26 164 -96 204 -178 23 -48 27 -70 27 -137 0 -132 -60 -233 -176 -296 -58 -32 -69 -34 -153 -34 -78 0 -97 4 -146 28 -66 32 -132 99 -162 165 -17 37 -22 66 -22 137 0 84 2 94 34 153 60 111 168 178 292 181 20 1 66 -8 102 -19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.74420b6ee4dbe890a36e626ad7a60c9c.svg";
export { ForwardRef as ReactComponent };